import React from 'react';
import Typography from '@material-ui/core/Typography/Typography';
import makeStyles from '@material-ui/core/styles/makeStyles';

const useStyles = makeStyles((theme: any) => ({
  container: {
    position: 'relative',
    display: 'grid',
    gridTemplateColumns: `0fr repeat(0, [col] 1fr) 0fr`,
    gridTemplateRows: `repeat(5, [row] 0fr)`,
    gridRowGap: theme.spacing(2),
    marginRight: theme.spacing(1),
    padding: theme.spacing(2),
    borderRadius: theme.spacing(2),
  },
  questionColumn: {
    borderRadius: '8px 10px 8px 10px',
    gridColumn: 1,
    minWidth: 200,
  },
}));

export default function Questions() {
  const classes = useStyles();

  const questions = [
    { text: 'TRANSPARENT ROW' },
    { text: 'How much capital will I need?' },
    { text: 'How much will it cost me?' },
    { text: 'How much of the risk will I bear?' },
    { text: 'How long will it take?' },
  ];

  return (
    <div className={classes.container}>
      {questions.map((question, id) => (
        <Typography
          key={id}
          variant={'subtitle2'}
          className={classes.questionColumn}
          style={{ gridRow: id + 1, color: id === 0 && 'transparent' }}
        >
          {question.text}
        </Typography>
      ))}
    </div>
  );
}
